import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledHeadingBar,
  StyledSectionBox,
} from "@/common/styles";
import UserInfoStaffGroups from "./UserInfoStaffGroups";
import { useEffect, useImperativeHandle, useState } from "react";
import StaffAdministrativeInformation from "./StaffAdministrativeInformation";
import UserInfoSecurityRulesControlling from "./UserInfoSecurityRulesControlling";
import ClientParamsDetails from "@/pages/Security/Sections/ClientParamsDetails";
import UserInfoRulesControllingAccess from "./UserInfoRulesControllingAccess";
import UserInfoCriteriaRulesControlling from "./UserInfoCriteriaRulesControlling";
import { useSelector, useDispatch } from "react-redux";
import { fetchSubmodules } from "@/apis/config/configApi";
import { Form } from "antd";
import { debounce } from "lodash";
import { setBookings } from "@/slices/bookingsSlice";
import {
  hasCheckSecurity,
  isNonEmptyVariable,
  validateStaffPassword,
} from "@/util/common_function";
import { fetchAllSecurityListOfStaff } from "@/apis/staff/staffApi";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import { SCHEMA_NAME } from "@/util/common_variable";
import SecureFormItem from "@/common/SecureFormItem";
import {
  Arbitrary_Names,
  Entity_types,
  Security_Types,
} from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

const PoliceCentralUserInfo = ({
  startingPoint = "",
  policeCentralUserRef,
}) => {
  const [form] = Form.useForm();

  useImperativeHandle(policeCentralUserRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
    form: form,
  }));
  const [isStaffMemberCanLogin, setIsStaffMemberCanLogin] = useState(false);
  const [staffGroupOptions, setStaffGroupOptions] = useState([]);
  const dispatch = useDispatch();
  const onChangeLoginCheck = (e) => {
    let isChecked = e.target.checked;
    dispatch(
      setBookings({
        isPoliceCentralUser: isChecked,
      }),
    );

    if (!isChecked) {
      let obj = {
        username: null,
        password: null,
        passwordLastUpdated: null,
        initialModule: null,
        initialSubmodule: null,
        securityLevel: null,
      };
      form.setFieldsValue({ ...obj });
      dispatch(
        setBookings({
          username: null,
          password: null,
          passwordLastUpdated: null,
          initialModule: null,
          initialSubmodule: null,
          securityLevel: null,
        }),
      );
    }
  };

  const { bookings, bookingsFieldsEnabled } = useSelector((s) => s?.bookings);
  const clientParamsList = useSelector((s) => s?.clientParams?.list);
  const moduleOptions = useSelector(
    (state) =>
      state.config.configModules
        ?.map((m) => ({
          value: m.moduleID,
          label: m.moduleName,
        }))
        ?.sort((a, b) => a.label.localeCompare(b.label)) || [],
  );
  const submoduleOptions = useSelector((state) => {
    const options =
      state.config.configSubModules
        ?.map((s) => ({
          value: s.subModuleID,
          label: s.subModuleName,
        }))
        ?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    return [{ value: null, label: "" }, ...options];
  });
  // const [policeCentralUserRef] = Form.useForm();
  const [form2] = Form.useForm();
  const staff = useSelector((s) => s.staff) || [];

  useEffect(() => {
    let {
      username,
      passwordLastUpdated,
      securityLevel,
      initialModule,
      initialSubmodule,
      isPoliceCentralUser,
    } = bookings || {};
    if (bookings?.isPoliceCentralUser)
      form.setFieldsValue({
        username,
        passwordLastUpdated,
        securityLevel,
        initialModule,
        initialSubmodule,
      });
    form2.setFieldsValue({ isPoliceCentralUser });
    setIsStaffMemberCanLogin(isPoliceCentralUser);
  }, [bookings]);

  let securityLevel = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
  ];
  let dataChange = debounce(() => {
    let obj = form.getFieldsValue();
    // if (!isNonEmptyVariable(obj?.password)) delete obj["password"];
    dispatch(
      setBookings({
        ...bookings,
        ...obj,
      }),
    );
  }, 600);

  useEffect(() => {
    if (bookings?.staffId)
      dispatch(fetchAllSecurityListOfStaff(bookings?.staffId));
  }, []);

  useEffect(() => {
    api
      .get(API_ENDPOINTS.security.staffGroups.getAll)
      .then((resp) => {
        const groupData = resp.data;

        const list = groupData
          ?.map((e) => ({
            value: e.staffGroupsID,
            label: e.groupName ?? "",
          }))
          ?.sort((a, b) => a.label.localeCompare(b.label));

        if (list?.length) {
          setStaffGroupOptions(list);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch staff groups", err);
      });
  }, []);

  const handleFieldsChange = ({ target: { name, value } }) => {
    const lettersOnly = value.replace(/[^a-zA-Z0-9]/g, "");
    form.setFieldValue("username", lettersOnly);
  };

  const validatePassword = (_, value) => {
    const { valid, message } = validateStaffPassword(value, clientParamsList);
    return valid ? Promise.resolve() : Promise.reject(new Error(message));
  };
  return (
    <>
      <StyledSectionBox>
        <StyledHeadingBar>
          <span className="main-title">Login Information</span>
        </StyledHeadingBar>

        <div className="content">
          <Form form={form2} disabled={!bookingsFieldsEnabled}>
            <StyledGridRow>
              <StyledGridCol>
                <FormItem
                  label="This Staff Member can Login to the System"
                  labelPostion="label-right"
                  layout="horizontal"
                  name="isPoliceCentralUser"
                  valuePropName="checked"
                >
                  <Checkbox
                    value={isStaffMemberCanLogin}
                    onChange={onChangeLoginCheck}
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
          {isStaffMemberCanLogin && (
            <>
              <FieldSecurityProvider
                entity={SCHEMA_NAME.STAFF}
                startingPoint={startingPoint}
                bookingsFieldsEnabled={bookingsFieldsEnabled}
              >
                <Form
                  form={form}
                  onFieldsChange={dataChange}
                  disabled={!bookingsFieldsEnabled}
                >
                  <StyledGridRow gutter={16}>
                    <StyledGridCol lg={8}>
                      <SecureFormItem
                        fieldName="username"
                        formItemProps={{ name: "username", label: "User Name" }}
                      >
                        <TextField onChange={handleFieldsChange} />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={8}>
                      <SecureFormItem
                        fieldName="password"
                        formItemProps={{
                          label: "Password",
                          name: "password",
                          autoComplete: "off",
                          rules: [{ validator: validatePassword }],
                          hasFeedback: true,
                        }}
                      >
                        <TextField
                          inputType="password"
                          visibilityToggle={false}
                          autoComplete="new-password"
                          // Show a masked placeholder when a password already exists on the
                          // record, without ever putting the real value into the form/DOM.
                          // Leaving the field empty on submit keeps the existing password
                          // (see Staffing/index.jsx payload.password fallback).
                          placeholder={
                            isNonEmptyVariable(bookings?.password)
                              ? "••••••••••"
                              : undefined
                          }
                        />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={8}>
                      <SecureFormItem
                        fieldName="passwordLastUpdated"
                        formItemProps={{
                          name: "passwordLastUpdated",
                          label: "Password Last Updated",
                        }}
                      >
                        <TextField disabled />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={8}>
                      <SecureFormItem
                        fieldName="initialModule"
                        formItemProps={{
                          name: "initialModule",
                          label: "Initial Module",
                        }}
                      >
                        <Select
                          options={moduleOptions}
                          onChange={(moduleId) => {
                            dispatch(fetchSubmodules(moduleId));
                          }}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={8}>
                      <SecureFormItem
                        fieldName="initialSubmodule"
                        formItemProps={{
                          name: "initialSubmodule",
                          label: "Submodule",
                        }}
                      >
                        <Select
                          options={submoduleOptions}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </SecureFormItem>
                    </StyledGridCol>

                    <StyledGridCol lg={8}>
                      <SecureFormItem
                        fieldName="securityLevel"
                        formItemProps={{
                          name: "securityLevel",
                          label: "Security Level",
                        }}
                      >
                        <Select
                          options={securityLevel}
                          disabled={!bookingsFieldsEnabled}
                        />
                      </SecureFormItem>
                    </StyledGridCol>
                  </StyledGridRow>
                </Form>
              </FieldSecurityProvider>
              {hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.arbitary,
                LABELS_CAPITAL.VIEW,
                Arbitrary_Names.ShowSecurityInStaffModule,
              ) && (
                <>
                  <UserInfoStaffGroups
                    bookingsFieldsEnabled={bookingsFieldsEnabled}
                    startingPoint={startingPoint}
                    staffGroupOptions={staffGroupOptions}
                  />

                  <UserInfoSecurityRulesControlling
                    bookingsFieldsEnabled={bookingsFieldsEnabled}
                    startingPoint={startingPoint}
                  />

                  <UserInfoRulesControllingAccess
                    bookingsFieldsEnabled={bookingsFieldsEnabled}
                    startingPoint={startingPoint}
                  />

                  <UserInfoCriteriaRulesControlling
                    bookingsFieldsEnabled={bookingsFieldsEnabled}
                    startingPoint={startingPoint}
                  />
                </>
              )}
            </>
          )}
        </div>
      </StyledSectionBox>
      {isStaffMemberCanLogin &&
        hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.arbitary,
          LABELS_CAPITAL.VIEW,
          Arbitrary_Names.ShowSecurityInStaffModule,
        ) && (
          <ClientParamsDetails
            headerSubTitle="List of Client Params for this Staff Member"
            bookingsFieldsEnabled={bookingsFieldsEnabled}
            startingPoint={startingPoint}
          />
        )}
      {/* <StaffAdministrativeInformation /> */}
    </>
  );
};
export default PoliceCentralUserInfo;
